import type { PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { parse } from 'query-string'
import { useOTL } from './useOTL'

export type OTLContextValue = string

export const OTLContext = createContext<string>('')

export function OTLContextProvider(props: PropsWithChildren): JSX.Element {
  const location = useLocation()
  const searchParams = parse(location.search, {
    parseBooleans: true
  })
  const isEmbed =
    window.location !== window.parent.location ||
    ('embed' in searchParams && searchParams.embed === true)

  const otlDisabledRoutes = ['/signup', '/login', '/onboarding']
  const isDisabled = isEmbed || otlDisabledRoutes.includes(location.pathname)
  const refreshKey = useOTL(isDisabled)

  return (
    <OTLContext.Provider value={refreshKey}>
      {props.children}
    </OTLContext.Provider>
  )
}

export function useOTLContext(): OTLContextValue {
  return useContext(OTLContext)
}
